import "./index.css";
import Map from "./Map";
import EventCard from "./EventCard";
import Schedule from "./Schedule";

import 'swiper/css';
import { Box,  Flex, Link, Tabs } from "@radix-ui/themes";
import JamList from "./JamList";
import About from "./About";
import BrainMade from "./BrainMade";

export function App() {
  return (
    <main className="flex flex-col items-center gap-2 md:px-[20%]">
      <h1 className="mt-20 p-4 text-4xl font-bold">UK Jazz Jams</h1>
      <EventCard />
      <Tabs.Root defaultValue="map" className="w-[90%]">
        <Tabs.List>
          <Tabs.Trigger value="map">Map</Tabs.Trigger>
          <Tabs.Trigger value="calendar">Calendar</Tabs.Trigger>
          <Tabs.Trigger value="list">List</Tabs.Trigger>
          <Tabs.Trigger value="about">About/Contact</Tabs.Trigger>
        </Tabs.List>

        <Box pt="3">
          <Tabs.Content value="map">
            <Map />
          </Tabs.Content>
          <Tabs.Content value="calendar">
            <Schedule />
          </Tabs.Content>
          <Tabs.Content value="list">
            <JamList />
          </Tabs.Content>
          <Tabs.Content value="about">
            <About />
          </Tabs.Content>
        </Box>
      </Tabs.Root>
      <Flex justifySelf="start" className="mt-1">
        <Link href="https://brainmade.org/" about="_blank">
        <BrainMade />
        </Link>
      </Flex>

    </main>
  );
}

export default App;
